"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScoreOutputIndex = exports.getSummaryResults = exports.questions = void 0;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var DRUG_USE = "DRUG_USE";
var questions = [{
  prompt: "Here’s the first question: Have you used drugs other than those required for medical reasons?",
  type: "radio",
  options: ["No", "Yes"],
  pointScale: [0, 1],
  batteryId: DRUG_USE,
  meta: {
    summaryTitle: "Here’s the first question: Have you used drugs other than those required for medical reasons?"
  }
}, {
  prompt: "Do you abuse more than one drug at a time?",
  type: "radio",
  options: ["No", "Yes"],
  pointScale: [0, 1],
  batteryId: DRUG_USE,
  meta: {
    summaryTitle: "Do you abuse more than one drug at a time?"
  }
}, {
  prompt: "Are you unable to stop using drugs when you want to?",
  type: "radio",
  options: ["No", "Yes"],
  pointScale: [1, 0],
  // reverse score for this one
  batteryId: DRUG_USE,
  meta: {
    summaryTitle: "Are you unable to stop using drugs when you want to?"
  }
}, {
  prompt: "Have you ever had blackouts or flashbacks as a result of drug use?",
  type: "radio",
  options: ["No", "Yes"],
  pointScale: [0, 1],
  batteryId: DRUG_USE,
  meta: {
    summaryTitle: "Have you ever had blackouts or flashbacks as a result of drug use?"
  }
}, {
  prompt: "Do you ever feel bad or guilty about your drug use?",
  type: "radio",
  options: ["No", "Yes"],
  pointScale: [0, 1],
  batteryId: DRUG_USE,
  meta: {
    summaryTitle: "Do you ever feel bad or guilty about your drug use?"
  }
}, {
  prompt: "Does your spouse (or parents) ever complain about your involvement with drugs?",
  type: "radio",
  options: ["No", "Yes"],
  pointScale: [0, 1],
  batteryId: DRUG_USE,
  meta: {
    summaryTitle: "Does your spouse (or parents) ever complain about your involvement with drugs?"
  }
}, {
  prompt: "Have you neglected your family because of your use of drugs?",
  type: "radio",
  options: ["No", "Yes"],
  pointScale: [0, 1],
  batteryId: DRUG_USE,
  meta: {
    summaryTitle: "Have you neglected your family because of your use of drugs?"
  }
}, {
  prompt: "Have you engaged in illegal activities in order to obtain drugs?",
  type: "radio",
  options: ["No", "Yes"],
  pointScale: [0, 1],
  batteryId: DRUG_USE,
  meta: {
    summaryTitle: "Have you engaged in illegal activities in order to obtain drugs?"
  }
}, {
  prompt: "Have you ever experienced withdrawal symptoms (felt sick) when you stopped taking drugs?",
  type: "radio",
  options: ["No", "Yes"],
  pointScale: [0, 1],
  batteryId: DRUG_USE,
  meta: {
    summaryTitle: "Have you ever experienced withdrawal symptoms (felt sick) when you stopped taking drugs?"
  }
}, {
  prompt: "Have you had medical problems as a result of your drug use (e.g. memory loss, hepatitis, convulsions, bleeding)?",
  type: "radio",
  options: ["No", "Yes"],
  pointScale: [0, 1],
  batteryId: DRUG_USE,
  meta: {
    summaryTitle: "Have you had medical problems as a result of your drug use (e.g. memory loss, hepatitis, convulsions, bleeding)?"
  }
}];
exports.questions = questions;

var getScoreOutputIndex = function getScoreOutputIndex(score) {
  if (score === 0) {
    return 0;
  } else if (score >= 1 && score <= 2) {
    return 1;
  } else if (score >= 3 && score <= 5) {
    return 2;
  } else if (score >= 6 && score <= 8) {
    return 3;
  } else if (score >= 9 && score <= 10) {
    return 3;
  }
};

exports.getScoreOutputIndex = getScoreOutputIndex;

var getSummaryResults = function getSummaryResults(answers) {
  return questions.map(function (question, index) {
    var _answers$question$bat;

    if (!question.hideFromSummary && (_answers$question$bat = answers[question.batteryId][index]) !== null && _answers$question$bat !== void 0 && _answers$question$bat.toString()) {
      if (question.type === "radio") {
        return {
          question: question,
          answer: question.options[answers[question.batteryId][index]]
        };
      } else {
        return {
          question: question,
          answer: answers[question.batteryId][index]
        };
      }
    }
  }).filter(function (item) {
    return _typeof(item) === "object";
  });
};

exports.getSummaryResults = getSummaryResults;